import React from 'react';
import Footer from "./Footer";
import '../styles/Disclaimer.css';

const Disclaimer = () => {
  return (
   <>
  <div className="disclaimer-page">
    <div className="disclaimer-container">
      <div className="disclaimer-content">
        <section className="disclaimer-header">
          <h1>⚠️ Disclaimer</h1>
          <p className="update-date">Laatst bijgewerkt: 27 maart 2025</p>
          <p className="intro-text">
            Deze website en de inhoud ervan worden aangeboden door Firgoquast AS als een gratis sociale entertainmentdienst.
          </p>
        </section>

        <section className="disclaimer-section gaming-section">
          <h2>🎮 Geen kansspelen</h2>
          <ul>
            <li><span>💸</span> Wij bieden geen spellen met echt geld aan</li>
            <li><span>❌</span> Je kunt geen geld of prijzen inzetten of winnen</li>
            <li><span>🆓</span> Alle spellen zijn 100% gratis te spelen</li>
            <li><span>🎯</span> Alle spellen zijn uitsluitend bedoeld voor entertainment</li>
          </ul>
        </section>

        <section className="disclaimer-section legal-section">
          <h2>🧑‍⚖️ Juridische aansprakelijkheid</h2>
          <p>Wij geven geen garanties over:</p>
          <ul>
            <li>De nauwkeurigheid of volledigheid van de spellen</li>
            <li>Dat het spelen op het platform leidt tot winst bij echte kansspelen</li>
            <li>Continue beschikbaarheid of technische foutloosheid</li>
          </ul>
          <p className="emphasis">Gebruik is volledig op eigen risico.</p>
        </section>

        <section className="disclaimer-section responsible-section">
          <h2>🧠 Speel verantwoord</h2>
          <p>
            Hoewel dit geen kansspelplatform is, moedigen we alle gebruikers aan om met mate te spelen en de principes van verantwoord spelen te volgen.
          </p>
          <p>
            Hulp nodig? Bezoek{' '}
            <a href="http://www.hjelpelinjen.no" target="_blank" rel="noopener noreferrer">
              www.hjelpelinjen.no
            </a>
          </p>
        </section>

        <section className="disclaimer-section contact-section">
          <h2>📬 Contact</h2>
          <p>Voor vragen over deze disclaimer:</p>
          <div className="contact-info">
            <p className="company-name">Firgoquast AS</p>
            <p>
              <span>📧</span>{' '}
              <a href="mailto:meister@gmail.com">meister@gmail.com</a>
            </p>
            <p>
              <span>📍</span> Dronning Eufemias gate 16, 0191 Oslo, Noorwegen
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
  <Footer />
</>

  );
};

export default Disclaimer;
